<template>
  <div class="w-100 position-relative d-flex align-items-center">
    <b-form @submit.prevent="submitSearch" class="w-100">
      <div class="d-flex align-items-center w-100">
        <div class="search-box-container">
          <div
            class="fake-input-wrapper"
            :class="{ 'clickable': hideSearch, 'is-disabled': disabledSubmit }"
            @click="onFakeInputClick"
          >
            <b-form-input
              class="custom-search-input"
              :value="query"
              :disabled="disabledSubmit"
              :placeholder="hideSearch ? 'Фильтры' : 'Поиск...'"
              :readonly="hideSearch"
              autocomplete="off"
              @input="onInput"
            />

            <div v-if="filterTags.length" class="tags-container">
              <b-badge
                v-for="(tag, index) in filterTags"
                :key="index"
                variant="secondary"
                class="custom-tag"
              >
                <span class="text-truncate" style="max-width: 150px;">{{ tag.label }}</span>
                <v-icon name="buttons/cross" :size="8" class="cursor-pointer ml-1" @click.stop="$emit('remove-tag', tag)"/>
              </b-badge>
            </div>
          </div>

          <button type="button" class="search-btn" :disabled="disabledSubmit" @click="handleActionClick">
            <v-icon :name="hideSearch ? 'buttons/filter' : 'buttons/search'"/>
          </button>
        </div>

        <div v-if="$slots.default && !hideSearch" class="ml-auto">
          <b-button class="custom-btn-secondary" @click.stop="toggleOpen">
            <v-icon name="buttons/filter" :size="11" class="mr-1"/>
            Фильтр
          </b-button>
        </div>
      </div>

      <transition name="flyout">
        <div v-show="isOpen" class="filters-flyout">
          <b-card no-body bg-variant="light" class="shadow-lg h-100 d-flex flex-column overflow-hidden">
            <div class="px-3 py-2 border-bottom rounded-top d-flex justify-content-between align-items-center flex-shrink-0">
              <h5 class="mb-0">Фильтр</h5>
              <b-button size="sm" variant="link" class="text-dark p-0" @click="toggleOpen">
                <font-awesome-icon icon="times"/>
              </b-button>
            </div>

            <div class="px-3 pb-2 pt-1 flyout-body bg-white overflow-auto flex-grow-1">
              <b-row><slot></slot></b-row>
            </div>

            <div class="px-3 py-2 border-top rounded-bottom d-flex justify-content-between align-items-center flex-shrink-0">
              <b-button variant="link" class="text-danger p-0" size="sm" @click="onClear">Очистить</b-button>
              <b-button class="custom-btn-primary" :disabled="disabledSubmit" @click="submitSearch">Найти</b-button>
            </div>
          </b-card>
        </div>
      </transition>

    </b-form>
  </div>
</template>

<script>
import {debounce} from "lodash";

export default {
  name: 'FiltersDrawer',
  props: {
    query: { type: String, default: '' },
    isBusy: { type: Boolean, default: false },
    filterTags: { type: Array, default: () => [] },
    hideSearch: { type: Boolean, default: false },
    hideSearchButton: { type: Boolean, default: false },
    disabledSubmit: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  created() {
    this.debouncedSearch = debounce(() => {
      this.$emit('submit');
    }, 300);
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    handleActionClick() {
      if (this.hideSearch) {
        this.toggleOpen();
      } else {
        this.submitSearch();
      }
    },
    onFakeInputClick() {
      if (this.hideSearch) this.toggleOpen();
    },
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    onInput(value) {
      if (this.hideSearch) return;

      this.$emit('update:query', value);
      this.debouncedSearch();
    },
    submitSearch() {
      if (this.debouncedSearch) this.debouncedSearch.cancel();

      this.$emit('submit');
      this.isOpen = false;
    },
    onClear() {
      if (this.debouncedSearch) this.debouncedSearch.cancel();

      this.$emit('clear');
    },
    handleOutsideClick(e) {
      if (!this.isOpen) return;

      if (this.$el.contains(e.target)) return;

      if (e.target.closest('.modal, .popover, .tooltip, .dropdown-menu')) return;

      this.isOpen = false;
    }
  }
};
</script>

<style scoped>
.fake-input-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1;
  min-height: 32px;
  background: #FFFFFF;
  border: 1px solid #DCE2EA;
  border-radius: 6px 0px 0px 6px;
  padding: 2px 8px;

  overflow: visible;
  height: auto;
  transition: all 0.2s ease-in-out;
}

.custom-tag {
  height: 22px;
  display: flex;
  align-items: center;
  background: #E9ECEF;
  color: #495057;
  font-weight: normal;
  font-size: 12px;
  border: none;
}

.search-box-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-width: 300px;
  width: auto;
  height: auto;
  min-height: 32px;
}

.custom-search-input {
  flex: 1 1 100px;
  border: none !important;
  box-shadow: none !important;
  font-size: 14px;
  height: 26px;
  background: transparent !important;
}

.tags-container {
  display: flex;
  gap: 4px;
}

.search-btn {
  align-self: stretch;
  width: 44px;
  background: #FFFFFF;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  border-color: #DCE2EA;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
}

.search-btn:hover {
  background: #f8f9fa;
  color: #333;
}

.filters-flyout {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: 450px;
  max-width: 90vw;
  max-height: 75vh;
  z-index: 10;
  transform-origin: top right;
  display: flex;
  flex-direction: column;
}

.filters-flyout .card {
  overflow: visible !important;
  max-height: none !important;
}

.flyout-body {
  min-height: 0;
  overflow: visible !important;
}

.flyout-enter-active,
.flyout-leave-active {
  transition: all 0.25s cubic-bezier(0.165, 0.85, 0.45, 1);
  opacity: 1;
  transform: scale(1) translateY(0);
}

.flyout-enter,
.flyout-leave-to {
  opacity: 0;
  transform: scale(0.95) translateY(-10px) translateX(10px);
}
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/FiltersDrawer.vue